var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStar = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 64,
  height: 64,
  viewBox: "0 0 64 64",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 32,
  r: 32,
  fill: "#FFE603"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M31.283 23.453c.23-.467.345-.7.502-.775a.5.5 0 0 1 .43 0c.157.074.272.308.502.775l2.187 4.43c.068.137.102.206.152.26a.502.502 0 0 0 .155.113c.067.03.143.042.295.064l4.891.715c.515.075.773.113.892.239a.5.5 0 0 1 .133.409c-.023.172-.21.353-.582.717L37.3 33.846c-.11.107-.165.16-.2.225a.5.5 0 0 0-.06.183c-.009.072.004.148.03.3l.835 4.867c.088.514.132.77.05.923a.5.5 0 0 1-.349.253c-.17.031-.4-.09-.862-.332l-4.373-2.3c-.136-.072-.204-.107-.276-.121a.498.498 0 0 0-.192 0c-.072.014-.14.05-.276.121l-4.373 2.3c-.461.242-.692.363-.862.332a.5.5 0 0 1-.348-.253c-.083-.153-.039-.41.05-.923l.834-4.867c.026-.152.039-.228.03-.3a.5.5 0 0 0-.06-.183c-.035-.064-.09-.118-.2-.225L23.16 30.4c-.373-.364-.56-.545-.583-.717a.5.5 0 0 1 .133-.41c.12-.125.377-.163.892-.238l4.891-.715c.152-.022.229-.033.295-.064a.5.5 0 0 0 .155-.113c.05-.054.084-.123.152-.26l2.187-4.43Z",
  stroke: "#000",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgStar;